import type { IconType } from 'react-icons';
import {
    FiActivity,
    FiCloud,
    FiCloudDrizzle,
    FiCloudLightning,
    FiCloudRain,
    FiCloudSnow,
    FiCompass,
    FiDroplet,
    FiEye,
    FiGlobe,
    FiMap,
    FiRadio,
    FiSun,
    FiThermometer,
    FiWind,
    FiZap,
} from 'react-icons/fi';

/**
 * سجلّ الأيقونات: قاعدة البيانات تخزّن اسم الأيقونة كنص (serializable)،
 * وهنا يُحوَّل الاسم إلى مكوّن react-icons. يُستخدم في الخريطة والداشبورد معاً.
 */
export const ICON_REGISTRY: Record<string, IconType> = {
    FiActivity,
    FiCloud,
    FiCloudDrizzle,
    FiCloudLightning,
    FiCloudRain,
    FiCloudSnow,
    FiCompass,
    FiDroplet,
    FiEye,
    FiGlobe,
    FiMap,
    FiRadio,
    FiSun,
    FiThermometer,
    FiWind,
    FiZap,
};

export const ICON_NAMES = Object.keys(ICON_REGISTRY);

export function getIconByName(name: string | null | undefined): IconType | null {
    if (!name) return null;
    return ICON_REGISTRY[name] ?? null;
}
